<template>
	<div class="popup-settings">
		<div class="settings-bg" v-hammer:tap="close"></div>
		<div class="settings-content">

			<div class="title">{{ 'settings' | lang }}</div>
			<div class="items">
				<div class="item">
					<div class="label">{{ 'language' | lang }}</div>
					<div class="value"><ui-switch :value="lang" slug="lang" :options="langs" @change="set_setting" /></div>
				</div>
				<!-- <div class="item">
					<div class="label">{{ 'musics' | lang }}</div>
					<div class="value"><ui-slider :value="user.settings.musics" slug="musics" @change="set_setting" /></div>
				</div> -->
				<div class="item">
					<div class="label">{{ 'volume' | lang }}</div>
					<div class="value"><ui-slider :value="user.settings.sounds" slug="sounds" @change="set_setting" /></div>
				</div>
				<div class="item">
					<div class="label">{{ 'quality' | lang }}</div>
					<div class="value"><ui-switch :value="user.settings.quality" slug="quality" :options="qualities" @change="set_setting" /></div>
				</div>
			</div>

		</div>

		<div class="reset-button" v-hammer:tap="reset_progression">{{ 'reset_progression' | lang }}</div>

	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import UiSlider from '@/components/ui/ui-slider'
import UiSwitch from '@/components/ui/ui-switch'
import UiButton from '@/components/ui/ui-button'
import Sounds from '@/js/sounds'

export default {
	name: 'popup-settings',
	data() {
		return {
			langs: [
				{ value: "en", text: "English" },
				{ value: "fr", text: "Français" }
			],
			qualities: [
				{ value: "low", text: "low" },
				{ value: "high", text: "high" }
			],
		}
	},
	computed: {
		...mapGetters([ 'lang', 'user' ])
	},
	methods: {
		popup(type) {
			this.$store.dispatch('add_popup', { type })
		},
		reset_progression() {
			this.$store.dispatch('add_popup', { type: 'reset' })
		},
		close() {
			this.$emit('close')
		},
		set_setting(data) {
			Sounds.play('button')
			const settings = { ...this.user.settings }
			settings[data.slug] = data.value
			this.$store.commit('EDIT_USER_STATE', { settings })
		}
	},
	components: { UiSlider, UiSwitch, UiButton }
}
</script>

<style lang="stylus" scoped>
@import '../../../assets/css/variables'

.popup-settings
	absolute 0
	flex center center
	.settings-bg
		absolute 0
	.settings-content
		height 100%
		width 100%
		max-height 550px
		width 400px
		padding 0 32px 32px 32px
		flex center center column
		color #fff
		transition 0.25s easeOutQuart
		// background-color dark
		// box-shadow 0 0 0 4px light
		.title
			margin 0 0 16px 0
			font-size 8rem
			line-height 1em
			text-align center
		.items
			width 100%
			margin 24px 0
			padding 24px 0
			// border-top 3px solid light
			// border-bottom 3px solid light
			.item
				flex center center
				// margin 0 0 8px 0
				height 56px
				line-height @height
				font-size 3.2rem
				// background-color alpha(black, 5%)
				// border-radius 4px
				.label
					width 35%
					// padding 0 0 0 16px
				.value
					width 65%
					height 100%
					// padding 0 16px 0 0
					text-align right
					flex center flex-end 
					>>> .ui-slider
						margin-right -8px
		.actions
			flex center center
			.action
				width 88px
				margin 0 16px
				flex center center column
				text-align center
				&.credits .icon
					background-position -32px -32px
				&.reset .icon
					background-position -64px -32px
				.icon
					width 32px
					height 32px
					background top left no-repeat
					background-size (96px * 2) auto
					margin 0 0 8px 0
				.text
					width 100%
		
	.reset-button
		position absolute
		left 48px
		bottom 32px
		color #fff
		opacity 0.5
		&:hover
			opacity 1
			
</style>
